import { BackstageOverrides } from '@backstage/core-components';
import { alpha, Theme } from '@mui/material/styles';
import {
  getSurfaceBorder,
  getSurfaceColor,
  getThemeTokens,
  radii,
} from '../tokens';

export const styledMuiPaper = (
  theme: Theme,
): BackstageOverrides['MuiPaper'] => {
  const tokens = getThemeTokens(theme);

  return {
    root: {
      backgroundColor: getSurfaceColor(theme, 'raised'),
      backgroundImage: 'none',
      border: `1px solid ${getSurfaceBorder(theme)}`,
      boxShadow: 'none',
    },
    rounded: {
      borderRadius: radii.lg,
    },
    elevation1: {
      boxShadow: 'none',
    },
    elevation2: {
      boxShadow: tokens.shadowSoft,
    },
    outlined: {
      backgroundColor: alpha(getSurfaceColor(theme, 'raised'), 0.98),
    },
  };
};
